import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';
import { Campaign, CampaignAction, CampaignStatus } from 'src/app/models/campaign';
import { UserRole } from 'src/app/models/user';

@Component({
    selector: 'app-campaign-action-buttons',
    templateUrl: './campaign-action-buttons.component.html',
    styleUrls: ['./campaign-action-buttons.component.scss']
})
export class CampaignActionButtonsComponent {
    @Input() campaign: Campaign;
    @Input() dataSource: any;
    @Output() onTriggerAction = new EventEmitter<{ type: CampaignAction; payload: any }>();
    currentUserRole: UserRole;
    CampaignAction = CampaignAction;
    campaignStatus = CampaignStatus;
    userStatusAction = {
        [UserRole.CLIENT]: {
            [CampaignStatus.DRAFT]: [CampaignAction.EDIT, CampaignAction.DELETE],
            [CampaignStatus.PENDING_APPROVAL]: [
                CampaignAction.EDIT,
                CampaignAction.PREVIEW,
                CampaignAction.CANCEL
            ],
            [CampaignStatus.PENDING_REAPPROVAL]: [
                CampaignAction.EDIT,
                CampaignAction.PREVIEW,
                CampaignAction.CANCEL
            ],
            [CampaignStatus.BEING_EDITED]: [
                CampaignAction.EDIT,
                CampaignAction.PREVIEW
            ],
            [CampaignStatus.PAUSED]: [
                CampaignAction.EDIT,
                CampaignAction.PREVIEW,
                CampaignAction.RELAUNCH,
                CampaignAction.CANCEL
            ],
            [CampaignStatus.PAUSED_PENDING_SUP_APPROVALS]: [
                CampaignAction.EDIT,
                CampaignAction.PREVIEW,
                CampaignAction.CANCEL
            ],
            [CampaignStatus.CANCELLED]: [CampaignAction.PREVIEW],
            [CampaignStatus.PARTIALLY_APPROVED]: [
                CampaignAction.PAUSE_VISUALS,
                CampaignAction.PAUSE,
                CampaignAction.PREVIEW,
                CampaignAction.CANCEL
            ],
            [CampaignStatus.APPROVED]: [
                CampaignAction.PAUSE_VISUALS,
                CampaignAction.PREVIEW,
                CampaignAction.PAUSE,
                CampaignAction.CANCEL
            ],
            [CampaignStatus.PARTIALLY_REJECTED]: [
                CampaignAction.EDIT,
                CampaignAction.PREVIEW,
                CampaignAction.CANCEL
            ],
            [CampaignStatus.REJECTED]: [
                CampaignAction.EDIT,
                CampaignAction.PREVIEW,
                CampaignAction.CANCEL
            ],
            [CampaignStatus.STOPPED]: [CampaignAction.PREVIEW],
            [CampaignStatus.COMPLETED]: [CampaignAction.PREVIEW],
            [CampaignStatus.LIVE]: [
                CampaignAction.PAUSE_VISUALS,
                CampaignAction.PREVIEW,
                CampaignAction.PAUSE,
                CampaignAction.CANCEL,
                CampaignAction.STOP
            ],
            [CampaignStatus.PARTIALLY_LIVE]: [
                CampaignAction.PAUSE_VISUALS,
                CampaignAction.PREVIEW,
                CampaignAction.PAUSE,
                CampaignAction.CANCEL,
                CampaignAction.STOP
            ]
        },
        [UserRole.SUPPLIER]: {
            [CampaignStatus.PENDING_APPROVAL]: [
                CampaignAction.APPROVE,
                CampaignAction.REJECT,
                CampaignAction.PREVIEW,
                CampaignAction.ADD_CHARGES,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.PENDING_REAPPROVAL]: [
                CampaignAction.APPROVE,
                CampaignAction.REJECT,
                CampaignAction.PREVIEW,
                CampaignAction.ADD_CHARGES,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.PAUSED]: [
                CampaignAction.PREVIEW,
                CampaignAction.ADD_CHARGES,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.CANCELLED]: [
                CampaignAction.PREVIEW,
                CampaignAction.ADD_CHARGES,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.APPROVED]: [
                CampaignAction.PREVIEW,
                CampaignAction.ADD_CHARGES,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.REJECTED]: [
                CampaignAction.PREVIEW,
                CampaignAction.ADD_CHARGES,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.STOPPED]: [CampaignAction.PREVIEW, CampaignAction.DOWNLOAD_MEDIA],
            [CampaignStatus.COMPLETED]: [CampaignAction.PREVIEW, CampaignAction.DOWNLOAD_MEDIA],
            [CampaignStatus.PAUSED_PENDING_SUP_APPROVALS]: [
                CampaignAction.PREVIEW,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.LIVE]: [CampaignAction.PREVIEW, CampaignAction.DOWNLOAD_MEDIA]
        },
        [UserRole.ADMIN]: {
            [CampaignStatus.DRAFT]: [CampaignAction.PREVIEW, CampaignAction.DOWNLOAD_MEDIA],
            [CampaignStatus.PENDING_APPROVAL]: [
                CampaignAction.APPROVE,
                CampaignAction.REJECT,
                CampaignAction.PREVIEW,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.PENDING_REAPPROVAL]: [
                CampaignAction.APPROVE,
                CampaignAction.REJECT,
                CampaignAction.PREVIEW,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.BEING_EDITED]: [CampaignAction.PREVIEW, CampaignAction.DOWNLOAD_MEDIA],
            [CampaignStatus.PAUSED]: [
                CampaignAction.RELAUNCH,
                CampaignAction.PREVIEW,
                CampaignAction.CANCEL,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.CANCELLED]: [CampaignAction.PREVIEW, CampaignAction.DOWNLOAD_MEDIA],
            [CampaignStatus.PARTIALLY_APPROVED]: [
                CampaignAction.CANCEL,
                CampaignAction.PREVIEW,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.PAUSED_PENDING_SUP_APPROVALS]: [
                CampaignAction.CANCEL,
                CampaignAction.PREVIEW,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.APPROVED]: [
                CampaignAction.PAUSE,
                CampaignAction.CANCEL,
                CampaignAction.PREVIEW,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.PARTIALLY_REJECTED]: [
                CampaignAction.CANCEL,
                CampaignAction.PREVIEW,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.REJECTED]: [
                CampaignAction.CANCEL,
                CampaignAction.PREVIEW,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.STOPPED]: [CampaignAction.PREVIEW, CampaignAction.DOWNLOAD_MEDIA],
            [CampaignStatus.COMPLETED]: [CampaignAction.PREVIEW, CampaignAction.DOWNLOAD_MEDIA],
            [CampaignStatus.LIVE]: [
                CampaignAction.PAUSE,
                CampaignAction.STOP,
                CampaignAction.CANCEL,
                CampaignAction.PREVIEW,
                CampaignAction.DOWNLOAD_MEDIA
            ],
            [CampaignStatus.PARTIALLY_LIVE]: [
                CampaignAction.PAUSE,
                CampaignAction.STOP,
                CampaignAction.DOWNLOAD_MEDIA,
                CampaignAction.PREVIEW
            ]
        }
    };

    constructor(private authenticationService: AuthenticationService) { }

    ngOnInit() {
        this.getCurrentUserRole();
    }

    getCurrentUserRole() {
        this.currentUserRole = this.authenticationService.getSessionRole();
    }

    isPausedBeingEdited() {
        return this.campaign.status == CampaignStatus.PAUSED && this.campaign.beingEdited;
    }

    canShowRestore(): boolean {
        if (this.currentUserRole !== UserRole.CLIENT) {
            return false;
        }

        if (this.campaign.status !== CampaignStatus.BEING_EDITED) {
            return false;
        }

        const allowedRelaunchStatuses = [
            CampaignStatus.PENDING_APPROVAL,
            CampaignStatus.PENDING_REAPPROVAL,
            CampaignStatus.REJECTED,
            CampaignStatus.PARTIALLY_REJECTED,
            CampaignStatus.PARTIALLY_APPROVED,
            CampaignStatus.APPROVED,
            CampaignStatus.PAUSED,
            CampaignStatus.LIVE,
            CampaignStatus.PARTIALLY_LIVE,
            CampaignStatus.PAUSED_PENDING_SUP_APPROVALS
        ];

        return allowedRelaunchStatuses.includes(this.campaign.relaunchStatus);
    }

    triggerAction(type: CampaignAction, payload: any) {
        this.onTriggerAction.emit({ type: type, payload: payload });
    }

    shouldShowAlertIcon(): boolean {
        return (
            this.currentUserRole === UserRole.ADMIN &&
            (this.campaign.status === CampaignStatus.PARTIALLY_APPROVED ||
                this.campaign.status === CampaignStatus.PARTIALLY_REJECTED ||
                this.campaign.status === CampaignStatus.APPROVED ||
                this.campaign.status === CampaignStatus.REJECTED) &&
            this.campaign.startsIn2WorkingDays
        );
    }

    getAlertTooltip(): string {
        return 'The starting day of the campaign is within 2 working days.';
    }
}
